import React, { Component } from 'react';
import Select from 'react-select';

import services from './data';

let CategoryOptions = [];

class LubesCategoryList extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      options: props.options || [],
    };
  }
  componentDidMount() {
    if (this.props.options) {
      return;
    }
    services
      .getLubesCategoryList()
      .then((response) => {
        const tmp = response.data.data;
        CategoryOptions = [];
        for (let i = 0; i < tmp.length; i++) {
          CategoryOptions.push({
            value: tmp[i].uuid,
            label: tmp[i].name,
          });
        }

        this.setState({ options: CategoryOptions });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  handleChange = (selectedOption) => {
    const i = this.props.did ? this.props.did : 0;
    let option = selectedOption;
    if (selectedOption == null) {
      option = { value: '', label: '' };
    }
    this.props.handleDropdownChange(option, i);
  };

  render() {
    const { options } = this.state;
    const { value, label } = this.props;

    let selectedOption = label
      ? options.find((option) => option.label === label)
      : options.find((option) => option.value === value);

    if (!selectedOption) {
      selectedOption = null;
    }
    return (
      <Select
        onChange={this.handleChange}
        options={options}
        isClearable={true}
        classNamePrefix="raw-select"
        name="bank"
        placeholder="Select category"
        value={selectedOption}
        menuPortalTarget={document.body}
      />
    );
  }
}

export { LubesCategoryList };
